module.exports = __webpack_public_path__ + "img/eyein-partner-samsung.bd27b017.webp";